import React from "react";

function OurServices() {
  return (
    <>
      {/* Service Start */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div
            className="section-title text-center position-relative pb-3 mb-5 mx-auto"
            style={{maxWidth: "600px"}}>
            <h5 className="fw-bold text-primary text-uppercase">Our Services</h5>
            <h1 className="mb-0">
              Custom Solutions for all your Digital Marketing Needs
            </h1>
          </div>
          <div className="row g-5">
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center"
              >
                <div className="service-icon">
                  <i className="fas fa-users text-white fs-2"></i>
                </div>
                <h4 className="mb-3">Organic Traffic (SEO)</h4>
                <p className="m-0">
                  We optimize your website for major search engines ensuring it
                  ranks higher organically, driving increased, targeted traffic to
                  your platform.
                </p>
                <button className="btn btn-lg btn-primary rounded">
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center"
              >
                <div className="service-icon">
                  <i className="fas fa-ad text-white fs-2"></i>
                </div>
                <h4 className="mb-3">Google Ads (SEM)</h4>
                <p className="m-0">
                  Maximize your online reach with our SEM strategies. We craft
                  compelling Google Ads campaigns that propel your brand to the
                  top of search results.
                </p>
                <button className="btn btn-lg btn-primary rounded">
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.9s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center"
              >
                <div className="service-icon">
                  <i className="fas fa-thumbs-up text-white fs-2"></i>
                </div>
                <h4 className="mb-3">Social Media Optimization (SMO)</h4>
                <p className="m-0">
                  Our SMO services focus on building and engaging your community
                  across all the major social platforms, enhancing brand awareness
                  and customer loyalty.
                </p>
                <button className="btn btn-lg btn-primary rounded">
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center"
              >
                <div className="service-icon">
                  <i className="fas fa-share-alt text-white fs-2"></i>
                </div>
                <h4 className="mb-3">Social Media Marketing (SMM)</h4>
                <p className="m-0">
                  Strategic social media advertising can help boost up your
                  brand's message. Our SMM campaigns target specific demographics,
                  resulting in meaningful engagement and a high ROI
                </p>
                <button className="btn btn-lg btn-primary rounded">
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center"
              >
                <div className="service-icon">
                  <i className="fas fa-cogs text-white fs-2"></i>
                </div>
                <h4 className="mb-3">On-Page SEO</h4>
                <p className="m-0">
                  We fine-tune your website's on-page elements, SEO techniques,
                  user experience, and technical enhancements that align with
                  search engine algorithms for optimal search performance.
                </p>
                <button className="btn btn-lg btn-primary rounded">
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center"
              >
                <div className="service-icon">
                  <i className="fas fa-bullhorn text-white fs-2"></i>
                </div>
                <h4 className="mb-3">Off-Page SEO</h4>
                <p className="m-0">
                  We build authoritative backlinks with off-page SEO strategies,
                  boosting your online credibility and improving search engine
                  rankings. Expand your digital footprint beyond your website.
                </p>
                <button className="btn btn-lg btn-primary rounded">
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center"
              >
                <div className="service-icon">
                  <i className="fas fa-tools fs-2 text-white"></i>
                </div>
                <h4 className="mb-3">Technical Analysis</h4>
                <p className="m-0">
                  Our technical analysis identifies and addresses issues,
                  optimizing site speed, responsiveness, and overall performance.
                  Ensure your website's technical aspects are top-notch.
                </p>
                <button className="btn btn-lg btn-primary rounded">
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center"
              >
                <div className="service-icon">
                  {/* <i className="fas fa-car-battery fs-2 text-white"></i> */}
                  <i className="far fa-file-word fs-2 text-white"></i>
                </div>
                <h4 className="mb-3">Web Content Writing</h4>
                <p className="m-0">
                  Our expert writers create engaging and SEO-friendly web content
                  that communicates your brand message effectively. Captivate your
                  audience with compelling content.
                </p>
                <button className="btn btn-lg btn-primary rounded">
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center"
              >
                <div className="service-icon">
                  <i className="fas fa-car-battery text-white fs-2"></i>
                </div>
                <h4 className="mb-3">Hybrid Services</h4>
                <p className="m-0">
                  Choose partial digital marketing services & experience the best
                  of both worlds with our hybrid SEO services. We seamlessly blend
                  organic strategies with paid campaigns.
                </p>
                <button className="btn btn-lg btn-primary rounded">
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center"
              >
                <div className="service-icon">
                  <i className="fas fa-user-tie fs-2 text-white"></i>
                </div>
                <h4 className="mb-3">Advisory Services</h4>
                <p className="m-0">
                  Receive personalized guidance from our team of digital marketing
                  experts. Our advisory services provide strategic insights,
                  helping you navigate the right way with confidence
                </p>
                <button className="btn btn-lg btn-primary rounded">
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center"
              >
                <div className="service-icon">
                  <i className="fas fa-globe fs-2 text-white"></i>
                </div>
                <h4 className="mb-3">Web Development</h4>
                <p className="m-0">
                  Bring your vision or ideas to life with our web development
                  services, from custom software to websites that look stunning
                  and offer seamless functionality and optimal user experience.
                </p>
                <button className="btn btn-lg btn-primary rounded">
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center"
              >
                <div className="service-icon">
                  <i className="fas fa-mobile-alt fs-2 text-white"></i>
                </div>
                <h4 className="mb-3">Mobile Development</h4>
                <p className="m-0">
                  Our mobile development solutions ensure your brand is accessible
                  and engaging across various devices, meeting the expectations of
                  today's on-the-go audience.
                </p>
                <button className="btn btn-lg btn-primary rounded">
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Service End */}
    </>
  );
}

export default OurServices;
